import { useContext } from 'react';
import { Formik, Field } from 'formik';
import CurrencyField from 'src/components/util/CurrencyField';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import PropValAndTaxInfoContext from 'src/contexts/prop-val-and-tax-info';
import { v4 as uuid } from 'uuid';
import * as Yup from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Modal, Button } from '@mui/material';

export default function PropertyValueTaxModal() {
  const { addAsset, display, editAsset, closeAndReset, selectedAsset, updateAsset, deleteAsset } =
    useContext(PropValAndTaxInfoContext);

  const initialValues = selectedAsset
    ? selectedAsset
    : {
        id: uuid(),
        interest: '',
        penaltyFees: '',
        taxes: '',
        total: '',
        yearsOfDeliquency: '',
      };

  const modalStyle = {
    bgcolor: 'background.paper',
    border: '2px solid #0f3c71',
    borderRadius: '10px',
    boxShadow: 24,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    left: '50%',
    maxHeight: '90%',
    mb: '1rem',
    overflow: 'auto',
    position: 'absolute',
    p: 4,
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
      xs: '95%',
      sm: '80%',
      md: '65%',
      lg: '40%',
    },
  };

  const schema = Yup.object().shape({
    interest: Yup.string(),
    penaltyFees: Yup.string(),
    taxes: Yup.string(),
    yearsOfDeliquency: Yup.string(),
  });

  return (
    <Modal onClose={closeAndReset} open={display}>
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={(vals) => {
            editAsset ? updateAsset(vals) : addAsset(vals);
          }}
          validationSchema={schema}
        >
          {(form) => {
            const handleFieldChange = (name, e) => {
              form.setFieldValue(name, e);
            };
            return (
              <>
                <Box sx={modalStyle}>
                  <Box sx={{ display: 'flex', justifyContent: 'end', mb: '2rem' }}>
                    <CloseIcon
                      onClick={closeAndReset}
                      sx={{
                        color: 'grey',
                        cursor: 'pointer',
                        float: 'right',
                      }}
                    />
                  </Box>
                  <Box>
                    <div className="flex flex-col gap-3">
                      <Field
                        InputLabelProps={{ shrink: true }}
                        component={MuiValidTextField}
                        label="Years of Delinquency (may go back five years)"
                        name="yearsOfDeliquency"
                        onChange={(e) => {
                          handleFieldChange('yearsOfDeliquency', e.target.value);
                        }}
                        type="number"
                      />

                      <CurrencyField
                        label="Taxes"
                        name="taxes"
                        onChange={(name, e) => {
                          handleFieldChange(name, e);
                        }}
                      />

                      <CurrencyField
                        label="Penalty / Fees"
                        name="penaltyFees"
                        onChange={(name, e) => {
                          handleFieldChange(name, e);
                        }}
                      />

                      <CurrencyField
                        label="Interest"
                        name="interest"
                        onChange={(name, e) => {
                          handleFieldChange(name, e);
                        }}
                      />

                      <CurrencyField
                        label="Total"
                        name="total"
                        onChange={(name, e) => {
                          handleFieldChange(name, e);
                        }}
                      />
                    </div>
                  </Box>

                  <div className={`flex ${editAsset ? 'justify-between' : 'justify-end'}`}>
                    {editAsset && (
                      <Box sx={{ display: 'flex', justifyContent: 'end', mt: '1rem' }}>
                        <Button
                          onClick={() => {
                            deleteAsset(selectedAsset);
                          }}
                          color="error"
                          variant="outlined"
                        >
                          Delete Asset
                        </Button>
                      </Box>
                    )}

                    <Box sx={{ display: 'flex', justifyContent: 'end', mt: '1rem' }}>
                      <Button
                        onClick={() => {
                          form.handleSubmit();
                        }}
                        variant="contained"
                      >
                        Save
                      </Button>
                    </Box>
                  </div>
                </Box>
                ;
              </>
            );
          }}
        </Formik>
      </div>
    </Modal>
  );
}
